// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { IndexForms } from "@hex-insights/app-modules";
import * as PostOrderFormValues from "./form-values";

/**
 * Returns a `formState` object for use in the order form of the Post model. Synchronizes
 * with the query state.
 */
export function useOrderFormStateWithQueryStateSync(defaultFormValues?: Partial<PostOrderFormValues.OrderFormValues>) {
	return IndexForms.useOrderFormStateWithQueryStateSync(
		() => PostOrderFormValues.getInitial(defaultFormValues),
		PostOrderFormValues.fieldValues,
	);
}

/**
 * Returns a `formState` object for use in the order form of the Post model.
 */
export function useOrderFormState(initialFormValues?: Partial<PostOrderFormValues.OrderFormValues>) {
	return IndexForms.useOrderFormState(() => PostOrderFormValues.getInitial(initialFormValues));
}
